import { PapiNetworkbarStrip } from '@wix/da-papi-types';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { DeviationTypes } from '@wix/da-shared-react/pkg/types/deviation';
import { useCallback, useContext } from 'react';
import { ItemTypes } from '../../../../constants';
import { getStripDeviationType, getStripType } from '../../../helpers/streams';
import {
  COMMISSION_STRIP_ITEM_SIZE,
  DEFAULT_STRIP_ITEM_SIZE,
  TIER_STRIP_ITEM_SIZE_MOBILE,
  TIER_STRIP_ITEM_SIZE,
} from '../constants';
import { Dims } from '@wix/da-shared-react/pkg/Measured';

export function useElementSize(strip: PapiNetworkbarStrip): Dims {
  const isMobile = useContext(MobileContext);
  const supportTiers = useFlag('tiers_in_strips');
  const type = getStripDeviationType(strip);

  switch (type) {
    case DeviationTypes.COMMISSION:
      return COMMISSION_STRIP_ITEM_SIZE;
    case DeviationTypes.TIER:
      if (!supportTiers) {
        return DEFAULT_STRIP_ITEM_SIZE;
      }
      return isMobile ? TIER_STRIP_ITEM_SIZE_MOBILE : TIER_STRIP_ITEM_SIZE;
    default:
      return DEFAULT_STRIP_ITEM_SIZE;
  }
}

export function useGetMeasuredElementSize(strip: PapiNetworkbarStrip) {
  const isMobile = useContext(MobileContext);
  const supportTiers = useFlag('tiers_in_strips');
  const type = getStripType(strip);

  const getMeasuredElementSize = useCallback(
    (defaultSize: Dims): Dims => {
      switch (type) {
        case ItemTypes.Gallection:
          return { ...defaultSize, height: 340 };
        case ItemTypes.Deviation:
          const deviationType = getStripDeviationType(strip);
          switch (deviationType) {
            case DeviationTypes.COMMISSION:
              return { ...defaultSize, height: 360 };
            case DeviationTypes.TIER:
              if (!supportTiers) {
                return defaultSize;
              }
              // tiers dont give a duck about measurements
              return isMobile
                ? TIER_STRIP_ITEM_SIZE_MOBILE
                : TIER_STRIP_ITEM_SIZE;
            default:
              return defaultSize;
          }
        default:
          return defaultSize;
      }
    },
    [isMobile, strip, supportTiers, type]
  );

  return getMeasuredElementSize;
}
